import selectPointEditMap from './reducers';

export default selectPointEditMap;
